export default {
    token: '',
    color: '',
    setLoginInfo(loginInfo) {
        Object.assign(this, loginInfo)
    }
}